import { useCallback, useState } from "react";

import { useDispatch } from "react-redux";
import { reset } from "redux-form";

import ImportResultModal from "~/components/ImportResultModal";
import { BOOK_SEARCH_FORM } from "~/constants/forms";
import { ADDRESS_BOOK_IMPORT_RESULT } from "~/constants/strings";
import ImportModal from "~/pages/AddressBook/components/ImportModal";
import { ADDRESSES } from "~/router";

const withImport = Component => props => {
  const [showImportModal, toggleImportModal] = useState(false);
  const [importResult, setImportResult] = useState(null);
  const dispatch = useDispatch();

  const openImportModal = useCallback(() => {
    toggleImportModal(true);
  }, []);

  const reloadPage = useCallback(() => {
    // eslint-disable-next-line react/prop-types
    props.history.push({
      pathname: ADDRESSES,
      state: {
        forceReload: true,
      },
    });
  }, []);

  const onSubmitImportResults = useCallback(() => {
    setImportResult(null);
    dispatch(reset(BOOK_SEARCH_FORM));
    reloadPage();
  }, []);

  const closeImportModal = useCallback(reload => {
    if (reload) {
      reloadPage();
    }

    toggleImportModal(false);
  }, []);

  return (
    <>
      {showImportModal && (
        <ImportModal
          show
          onClose={closeImportModal}
          onSubmitImport={setImportResult}
        />
      )}
      {!!importResult && (
        <ImportResultModal
          show
          onSubmit={onSubmitImportResults}
          titleImportResult={ADDRESS_BOOK_IMPORT_RESULT}
          {...importResult}
        />
      )}
      <Component {...props} openImportModal={openImportModal} />
    </>
  );
};

export default withImport;
